@import "./../../less/variables.less";

.header {
  justify-content: space-between;
  border-bottom: 1px solid var(--dds-melkeskum);
  width: 100%;
  display: flex;
  align-items: center;
  height: @header-height;
  padding: 0 var(--dds-spacing-small-8);

  @media @dds-breakpoint-tablet-landscape-up {
    padding: 0 var(--dds-spacing-medium-32);
  }
}

.headerItem:hover {
  border-bottom: 3px solid #fa2d16;
  color: #444;
  cursor: pointer;
}

.headerItem {
  margin: 0 0 0 0.6em;
  line-height: 1em;
  white-space: nowrap;
  border: none;
  font-weight: 400;
  font-size: var(--dds-font-size-small);
  background: none;
}

.headerMobileVersion {
  display: block;
  outline: none;

  @media @dds-breakpoint-tablet-landscape-up {
    display: none;
  }
}

.mobilemenuOpener {
  display: flex;
  margin-right: var(--dds-spacing-medium-32);
  width: 30px;
  height: 20px;
  transition: 0.5s ease-in-out;
  cursor: pointer;

  @media @dds-breakpoint-tablet-landscape-up {
    background: transparent;
    border-width: 0;
  }
}

.mobilemenuIcon {
  height: 1.5em;
  width: 1.5em;
  cursor: pointer;
  color: var(--dds-sort-kaffe);
}

.headerLanguageMenu {
  display: none;
  background-color: white;

  @media @dds-breakpoint-tablet-landscape-up {
    display: flex;
  }

  flex-direction: column;
  position: absolute;
  top: 80px;
  right: 0;
}

.headerLanguageLink {
  display: block;
  color: var(--dds-sort-kaffe);
  padding: var(--dds-spacing-small-16);
  text-decoration: none;
  border: none;
  border-top: 1px solid var(--dds-melkeskum);
}

.headerLanguageLink:hover {
  background-color: var(--dds-melkeskum);
}

.headerLanguageList {
  list-style-type: none;
  margin: 0;
  padding-left: 0;
}
